import { STATUS_STYLES } from "@/lib/api";

export default function StatusPill({ status, testId }) {
    const style = STATUS_STYLES[status] || STATUS_STYLES.Active;
    return (
        <span data-testid={testId} className={`status-pill ${style.cls}`}>
            {status}
        </span>
    );
}
